<script>
/**
 * Index
 * @version 1.0.0
 * @since
 */

import { distributorAuthorize } from '@/api/endpoints/quick-books';
import EzLoader from '@/components/ui/Loader/EzLoader';

export default {
  components: {
    EzLoader,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  async created() {
    if (!this.$route.query) {
      this.$router.push({
        name: 'distributor-quick-books-not-connected',
        params: {
          flash: {
            message: 'Something went wrong!',
            type: 'error',
          },
        },
      });
    } else {
      const params = window.location.search;
      try {
        this.isLoading = true;
        await distributorAuthorize(params);
        this.$router.push({
          name: 'distributor-quick-books-account',
          params: {
            flash: {
              title: this.$t('quickBooks.integrations.flashMessage.success.title'),
              message: this.$t('quickBooks.integrations.flashMessage.success.message'),
              type: 'success',
            },
          },
        });
      } catch (e) {
        this.$router.push({
          name: 'distributor-quick-books-not-connected',
          params: {
            flash: {
              message: 'Something went wrong!',
              type: 'error',
            },
          },
        });
      } finally {
        this.isLoading = false;
      }
    }
  },
};
</script>
<template>
  <ez-loader :show="isLoading">Loading...</ez-loader>
</template>
<style lang="scss" scoped></style>
